import createHistory from 'history/createBrowserHistory';
let history = createHistory();
// window.history_obj  = history;
export default history;
